export enum SharedDataDetail {
    KEY = 'detail',
}
